import { render, staticRenderFns } from "./SifcopTable.vue?vue&type=template&id=78126864&scoped=true"
import script from "./SifcopTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SifcopTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SifcopTable.vue?vue&type=style&index=0&id=78126864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78126864",
  null
  
)

export default component.exports